import { render, staticRenderFns } from "./FileAssets.vue?vue&type=template&id=0a1bdde5"
import script from "./FileAssets.vue?vue&type=script&lang=js"
export * from "./FileAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports